function replaceUrlParam(url, paramName, paramValue)
{
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
    if (url.search(pattern)>=0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/,'');
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}
$(document).ready(function(){

// Save existing sort parameters
Shopify.queryParams = {};
if(location.search.length) {
    for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
    }
}

// Add existing sort parameters to current URL
$('#SortBy').on('change', function(e) {
    var value = e.currentTarget.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});
$('#SortByD').on('change', function(e) {
    var value = e.currentTarget.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});
  
  
  $('#exit-filter').click(function(){
  	$('#mobile-filters').removeClass('active');
    scrollLock.enablePageScroll();
  });
  $('.filter-trigger').on('click', function(){
  	$('#mobile-filters').addClass('active');
    scrollLock.disablePageScroll();
  });
  $('#desktop-filters.cc-collection-filters .filter-button').on('click', function(){
    var findOptions = 'optionsD-' + $(this).attr('data-trigger');
    if($(this).hasClass('active')){
    	$(this).removeClass('active');
      	$('#' + findOptions).removeClass('active');
    }
    else{
        $('#desktop-filters.cc-collection-filters .filter-button').removeClass('active');
        $('#desktop-filters.cc-collection-filters .nav').removeClass('active');
    	$(this).addClass('active');
      	$('#' + findOptions).addClass('active');
    }
  });
  $('#mobile-filters.cc-collection-filters .filter-button').on('click', function(){
    var findOptions = 'optionsM-' + $(this).attr('data-trigger');
    if($(this).hasClass('active')){
    	$(this).removeClass('active');
      	$('#' + findOptions).removeClass('active');
    }
    else{
        $('#mobile-filters.cc-collection-filters .filter-button').removeClass('active');
        $('#mobile-filters.cc-collection-filters .nav').removeClass('active');
    	$(this).addClass('active');
      	$('#' + findOptions).addClass('active');
    }
  });

/* $("a[href='#top']").on('click', function(e) {
  e.preventDefault();
  $("html, body").animate({ scrollTop: 0 });
});
$(window).on('scroll', function() {
    var y_scroll_pos = window.pageYOffset;
    var scroll_pos_test = 150;

    if(y_scroll_pos > scroll_pos_test) {
      $("#cc-scroll-top").show();
    }
  	else{
  		$("#cc-scroll-top").hide();
    }
}); */

var moreColorsSwiper = new Swiper(".more-colors-slider", {
  slidesPerView: 2,
  slidesPerGroup: 2,
  navigation: {
    enabled: false
  },
  breakpoints: {
    900: {
      spaceBetween: 5,
      slidesPerView: 3,
      slidesPerGroup: 3,
      loopAddBlankSlides: false,
      loop: true,
      navigation: {
        enabled: true,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    },
  }
})
$("body").on('click', '.readers-powers button', function(){
	var vId = $(this).attr('variant-id');
  	var vStatus = $(this).attr('variant-status');
    var newPower = $(this).attr('variant-name').replace('+', '');
  	var atcForm = $(this).closest('.cc-collection-item').find('.shopify-product-form:first');
  	var container = $(this).parent();
  	var mainContainer = $(this).closest('.cc-collection-item');
    var urlSelector = $('.featured-container', mainContainer);
    var myHref = urlSelector.attr("href");
    var newHref = replaceUrlParam(myHref, 'power', newPower);
    urlSelector.attr("href", newHref);
  	$('.main-info h4 a', mainContainer).attr("href", newHref);
  	$('.review-wrap', mainContainer).attr("href", newHref);
  
  	$('button', container).removeClass('selected');
  	$(this).addClass('selected');
  	$('input[name=id]', atcForm).val(vId);
  	$('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  	if(vStatus == "true"){
    	$('.BIS_trigger', atcForm).hide();
      	$('[data-atc]', atcForm).show();
    }
  	else{
    	$('.BIS_trigger', atcForm).show();
      	$('[data-atc]', atcForm).hide();
    }
});
$("body").on('click', ".snow-helmet-sizes button", function(){
	var vId = $(this).attr('variant-id');
  	var vStatus = $(this).attr('variant-status');
  	var atcForm = $(this).closest('.cc-collection-item').find('.shopify-product-form:first');
  	var container = $(this).parent();
  	$('button', container).removeClass('selected');
  	$(this).addClass('selected');
  	$('input[name=id]', atcForm).val(vId);
  	$('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  	if(vStatus == "true"){
    	$('.BIS_trigger', atcForm).hide();
      	$('[data-atc]', atcForm).show();
    }
  	else{
    	$('.BIS_trigger', atcForm).show();
      	$('[data-atc]', atcForm).hide();
    }
});
$("body").on('click', ".rx-lens-colors .rx-swatch", function(){  
    var newImg = $(this).attr('rx-image');
    var newColor = $(this).attr('rx-color');
  	var container = $(this).closest('.cc-collection-item');
    var imgSelector = $('.featured-container img', container);
    var urlSelector = $('.featured-container', container);
    var myHref = urlSelector.attr("href");
    var newHref = replaceUrlParam(myHref, 'color', newColor);
  	$('.rx-lens-colors .rx-swatch', container).removeClass('selected');
  	$(this).addClass('selected');
    urlSelector.attr("href", newHref);
    imgSelector.attr("src", newImg);
    imgSelector.attr("data-hover-src", newImg);
  	$('.main-info h4 a', container).attr("href", newHref);
  	$('.review-wrap', container).attr("href", newHref);
    $('.shopify-product-form a', container).attr("href", newHref); 
 }); 

 function formatPrice(price, currency) {
   return new Intl.NumberFormat('en-US', {
     style: 'currency',
     currency: currency
   }).format(price);
 }

 var shopCurrency = Shopify.currency.active;

 function getLocalizedPrice(price, callback) {
    var convertedPrice = price;
    callback(convertedPrice);
 }

 $('body').on('click','.sun-variants .sw-extra', function(){
	var newImg = $(this).attr('data-image');
  var newPrice = $(this).attr('data-price');
  var newHoverImg = $(this).attr('data-hover-image');
  var mainContainer = $(this).closest('.cc-collection-item');
  var imgSelector = $('.featured-container img', mainContainer);
  var priceSelector = $('.main-info .flow-price', mainContainer);
  var myHref = $(this).attr('data-href');
  var vId = $(this).attr('variant-id');
  var vJson = $(this).attr('data-product-json');
  var vStatus = $(this).attr('variant-status');
  var container = $(this).parent();
  var atcForm = $('.shopify-product-form', mainContainer);
  $('.sw-extra .bl-color-sun', container).removeClass('active');
  $('.bl-color-sun',this).addClass('active');
  imgSelector.attr("src", newHoverImg).attr('data-hover-src', newImg);
  $('.main-info h4 a', mainContainer).attr("href", myHref);
  $('.review-wrap', mainContainer).attr("href", myHref);
  $('.featured-container',mainContainer).attr("href", myHref);;
  $('input[name=id]', atcForm).val(vId);
  $('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  $('.BIS_trigger', atcForm).attr('data-product-data',vJson);
  if(vStatus == "true"){
    $('.BIS_trigger', atcForm).hide();
      $('[data-atc]', atcForm).show();
  }
  else{
    $('.BIS_trigger', atcForm).show();
      $('[data-atc]', atcForm).hide();
  }
  // if (typeof Flow.getExperience === "function" && Flow.getExperience()) {
  //   priceSelector.attr("flow-variant", vId).attr('flow-default', newPrice);
  //   Flow.variants.localize(({ force: true }));
  // } else {
  //   priceSelector.attr("flow-variant", vId).attr('flow-default', newPrice).text(newPrice);
  // }
  getLocalizedPrice(newPrice, function(localizedPrice) {
    priceSelector
      .attr("globale-variant", vId)
      .attr("globale-default", newPrice)
      .text(formatPrice(localizedPrice, shopCurrency));
  });
});
  $('.cc-collection-item [data-atc]').on('click', function(){
    var _learnq = _learnq || [];
    var klProductData = JSON.parse($(this).siblings('.BIS_trigger').attr('data-product-data'));
    var klCollections = $(this).attr('data-collections');
    var mainPrice = (klProductData.price / 100).toFixed(2).replace('.00', '');
	var comparePrice = "";
    if(klProductData.compare_at_price_max > 0 ){
    	comparePrice = (klProductData.compare_at_price_max / 100).toFixed(2).replace('.00', '');
    }
    var klDataObj = {
      Name: klProductData.title,
      ProductID: klProductData.id,
      Categories: klCollections,
      ImageURL: "https:" + klProductData.featured_image,
      URL: "https://blenderseyewear.com/products/" +  klProductData.handle,
      Brand: klProductData.vendor,
      Price: mainPrice,
      CompareAtPrice: comparePrice
    }
    _learnq.push(['track', 'Added to Cart', klDataObj]);
  });
  $('#learn-more.read').on('click', function(){
  	$('#learn-more-content').slideToggle();
    $(this).toggleClass('active');
    if($('span',this).text() == "Read More"){
    	$('span',this).text("Read Less");
    }else{
		$('span',this).text("Read More");
    }
  });
});
